import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PhotoQualityService {
  private _isHighQualityMode$ = new BehaviorSubject<boolean>(false);
  isHighQualityMode$ = this._isHighQualityMode$.asObservable();

  constructor() {}

  toggleQualityMode() {
    this._isHighQualityMode$.next(!this._isHighQualityMode$.value);
  }

  setQualityMode(isHighQuality: boolean) {
    this._isHighQualityMode$.next(isHighQuality);
  }

  isHighQualityMode(): boolean {
    return this._isHighQualityMode$.value;
  }
}
